import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { EventService } from '../../core/services/event.service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { getSidebarSize } from 'src/app/store/layouts/layout-selector';
import { RootReducerState } from 'src/app/store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-vertical',
  templateUrl: './vertical.component.html',
  styleUrls: ['./vertical.component.scss']
})

export class VerticalComponent implements OnInit {

  private getsize: any;

  constructor(
    private activatedRoute   : ActivatedRoute,
    private eventService     : EventService,
    private exceptionsService: ExceptionsService,
    private router           : Router,
    private store            : Store<RootReducerState>,

  ) {
    
  }

  public ngOnInit(): void {
    try {
      this.router.events.subscribe((event: any) => {
        if (document.documentElement.getAttribute('data-preloader') == 'enable') {
          if (event instanceof NavigationEnd) {
            // Update the attribute state based on the current route or any other conditions
            if (event.url !== '/disabled-route') {
              (document.getElementById("preloader") as HTMLElement).style.opacity = "1";
              (document.getElementById("preloader") as HTMLElement).style.visibility = "";
              setTimeout(() => {
                (document.getElementById("preloader") as HTMLElement).style.opacity = "0";
                (document.getElementById("preloader") as HTMLElement).style.visibility = "hidden";
              }, 1000);
            } else {
              (document.getElementById("preloader") as HTMLElement).style.opacity = "0";
              (document.getElementById("preloader") as HTMLElement).style.visibility = "hidden";
            }
          }
        }
      });
  
      this.handlePreloader(this.activatedRoute.snapshot.routeConfig?.path);
      if (document.documentElement.getAttribute('data-sidebar-size') == 'lg') {
        this.store.select(getSidebarSize).subscribe((size) => {
          this.getsize = size
          })
        window.addEventListener('resize', () => {
          var self = this;
          if (document.documentElement.clientWidth <= 767) {
            document.documentElement.setAttribute('data-sidebar-size', '');
            document.querySelector('.hamburger-icon')?.classList.add('open')
          }
          else if (document.documentElement.clientWidth <= 1024) {
            document.documentElement.setAttribute('data-sidebar-size', 'sm');
            document.querySelector('.hamburger-icon')?.classList.add('open')
          }
          else if (document.documentElement.clientWidth >= 1024) {
            if(document.documentElement.getAttribute('data-layout-width') == 'fluid'){
              document.documentElement.setAttribute('data-sidebar-size', self.getsize);
              document.querySelector('.hamburger-icon')?.classList.remove('open')
            }
          }
        })
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private handlePreloader(route: any) {
    try {
      const preloader=document.getElementById("preloader") as HTMLElement;

      if (route !== '/disabled-route') {
        preloader.style.opacity   ="1";
        preloader.style.visibility="";
        setTimeout(() => {
          const _preloader=document.getElementById("preloader") as HTMLElement;

          if (_preloader) {
            _preloader.style.opacity   ="0";
            _preloader.style.visibility="hidden";
          }
        }, 1000);
      } else {
        preloader.style.opacity   ="0";
        preloader.style.visibility="hidden";
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public onToggleMobileMenu() {
    try {
      const currentSIdebarSize = document.documentElement.getAttribute("data-sidebar-size");
      if (document.documentElement.clientWidth >= 767) {
        if (currentSIdebarSize == null) {
          (document.documentElement.getAttribute('data-sidebar-size') == null || document.documentElement.getAttribute('data-sidebar-size') == "lg") ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg')
        } else if (currentSIdebarSize == "md") {
          (document.documentElement.getAttribute('data-sidebar-size') == "md") ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'md')
        } else {
          (document.documentElement.getAttribute('data-sidebar-size') == "sm") ? document.documentElement.setAttribute('data-sidebar-size', 'lg') : document.documentElement.setAttribute('data-sidebar-size', 'sm')
        }
      }
  
      if (document.documentElement.clientWidth <= 767) {
        document.body.classList.toggle('vertical-sidebar-enable');
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public onSettingsButtonClicked() {
    try {
      document.body.classList.toggle('right-bar-enabled');
      const rightBar = document.getElementById('theme-settings-offcanvas');
      if (rightBar != null) {
        rightBar.classList.toggle('show');
        rightBar.setAttribute('style', "visibility: visible;");
  
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onResize(event: any) {
    try {
      if (document.body.getAttribute('layout') == "twocolumn") {
        if (event.target.innerWidth <= 767) {
          this.eventService.broadcast('changeLayout', 'vertical');
        } else {
          this.eventService.broadcast('changeLayout', 'twocolumn');
          document.body.classList.remove('twocolumn-panel');
          document.body.classList.remove('vertical-sidebar-enable');
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
